import type { ProductLogoMediumProps } from '../types';

export function ProductLogoMediumIDs({
  size = 40,
  ...props
}: ProductLogoMediumProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 672 672"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <title>IDs</title>
      <rect width="672" height="672" rx="100" fill="#1A2142" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M336 120C448.666 120 540 211.334 540 324C540 368.853 525.524 410.325 500.99 444H470.163C498.666 412.154 516 370.102 516 324C516 224.589 435.411 144 336 144C236.589 144 156 224.589 156 324C156 372.421 175.122 416.374 206.223 448.727C214.933 411.624 248.24 384 288 384H384C422.052 384 454.195 409.302 464.521 444H324C304.118 444 288 460.118 288 480V522.319C198.495 500.734 132 420.133 132 324C132 211.334 223.334 120 336 120ZM228 468.011C228 468.007 228 468.004 228 468H227.985C227.99 468.004 227.995 468.007 228 468.011Z"
        fill="white"
      />
      <path
        d="M336 216C375.764 216 408 248.236 408 288C408 327.764 375.764 360 336 360C296.236 360 264 327.764 264 288C264 248.236 296.236 216 336 216Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M588 468C594.627 468 600 473.373 600 480V564C600 570.627 594.627 576 588 576H324C317.373 576 312 570.627 312 564V480C312 473.373 317.373 468 324 468H588ZM366 504C356.059 504 348 512.059 348 522C348 531.941 356.059 540 366 540C375.941 540 384 531.941 384 522C384 512.059 375.941 504 366 504ZM426 504C416.059 504 408 512.059 408 522C408 531.941 416.059 540 426 540C435.941 540 444 531.941 444 522C444 512.059 435.941 504 426 504ZM486 504C476.059 504 468 512.059 468 522C468 531.941 476.059 540 486 540C495.941 540 504 531.941 504 522C504 512.059 495.941 504 486 504ZM546 504C536.059 504 528 512.059 528 522C528 531.941 536.059 540 546 540C555.941 540 564 531.941 564 522C564 512.059 555.941 504 546 504Z"
        fill="#57D7D9"
      />
    </svg>
  );
}
